// extracted by mini-css-extract-plugin
export var attachment = "_rl-a";
export var emailContainer = "_rl-4";
export var emailContentPaddedContainer = "_rl-b";
export var emailHeader = "_rl-6";
export var emailIframe = "_rl-3";
export var emailInfoIcon = "_rl-9";
export var emailShortenedSummary = "_rl-e";
export var infoDropdown = "_rl-0";
export var infoRowBoundedContent = "_rl-d";
export var internal = "_rl-5";
export var merchant = "_rl-8";
export var messageInputContainer = "_rl-h";
export var normal = "_rl-7";
export var replyCard = "_rl-f";
export var subtleButton = "_rl-1";
export var subtleButtonIconContainer = "_rl-2";
export var toggleViewRepliesButton = "_rl-c";
export var wrappingText = "_rl-g";